'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = reducer;
exports.set = set;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET = 'notifications/SET';

var initialState = [];

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET:
      return [].concat((0, _toConsumableArray3.default)(action.notifications.items));
    default:
      return state;
  }
}

function set(notifications) {
  return {
    type: SET,
    notifications: notifications
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/notifications.js
// module id = 590
// module chunks = 0